import { fetchManagedAccounts } from "./fetchManagedAccounts";
import { type Dispatch } from "redux";
import { HTTP_404 } from "../utils/constants";
import CONFIG from "../model/TSConfig";
import { ONBOARDING, SIGNUP } from "../utils/routes/routes";
import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import { setAccountToDisplay, setManagedAccounts } from "../redux/actions/user";
import { fetchEventsAndPOSAData, setError } from "../redux/actions/app";
import { deleteMasterTokenFromStorage } from "../utils/helpers/localStorage";
import { processPostSignIn } from "../utils/helpers/processPostSignIn";
import { RootStateI } from "../redux";
import { buildPathWithTrackingId } from "../utils/routing/routingUtils";
import { assignFreePlan } from "../app/13_SaaS/api";
import SubscriptionPlanDTO from "@tootsweet/model/datatransfer/SubscriptionPlanDTO";

const fetchAllManagedAccounts =
  ({
    isSignIn,
    history,
    mustAssignFreePlan,
    plan
  }: {
    isSignIn?: boolean;
    history?: any;
    mustAssignFreePlan?: boolean;
    plan?: SubscriptionPlanDTO;
  }) =>
  async (dispatch: Dispatch, getState: () => RootStateI) => {
    const masterToken = getState().user.masterToken;

    if (!masterToken) {
      return [];
    }

    try {
      const managedAccountsRes = await fetchManagedAccounts(masterToken);

      if (typeof managedAccountsRes === "string") {
        dispatch(setError(managedAccountsRes));
        return;
      }

      const managedAccounts: ManagedAccount[] = managedAccountsRes.map(
        (user: ManagedAccount) => ({ ...user, isAll: false })
      );
      dispatch(setManagedAccounts(managedAccounts));

      // Only set the first managed account if no account is currently selected
      const currentAccountToDisplay = getState
        ? getState().user?.accountToDisplay
        : undefined;

      let accountToDisplay = currentAccountToDisplay;

      if (managedAccounts.length > 0 && !currentAccountToDisplay) {
        accountToDisplay = managedAccounts[0];
        dispatch(setAccountToDisplay(accountToDisplay));
      }

      if (isSignIn) {
        if (accountToDisplay) {
          console.log("isSignIn but acountToDisplay", accountToDisplay);
          processPostSignIn(accountToDisplay, dispatch, history);
        } else {
          console.log("isSignIn but no accountToDisplay");
        }
      }

      if (
        !isSignIn &&
        mustAssignFreePlan &&
        plan &&
        managedAccounts?.length > 0
      ) {
        const account = managedAccounts[0];
        const trackingID = account.trackingID;

        if (trackingID) {
          await assignFreePlan(
            trackingID,
            plan._id,
            plan.name || "",
            account.token
          );
          void fetchAllManagedAccounts({ isSignIn: false, history: history })(
            dispatch,
            getState
          );
          void fetchEventsAndPOSAData()(dispatch);
          console.log("e");
          history.push(buildPathWithTrackingId(ONBOARDING, trackingID));
          return;
        }
      }

      return managedAccounts;
    } catch (err) {
      // @ts-ignore
      if (err.response.status === HTTP_404) {
        deleteMasterTokenFromStorage();
        window.location.pathname = `/${CONFIG.baseName}${SIGNUP}`;
      }
    }
  };

export default fetchAllManagedAccounts;
